<template>
  <b-container fluid
               id="disclosure-new-form">
    <div id="disclosure-new-form">
      <b-card>
        <div class="card-header"
             id="title-card">
          <!-- 보고서 ID -->
          <span v-if="disclosure.disclosureId"
                class="project-id">{{ disclosure.disclosureId }}</span>
          <!-- /보고서 ID -->

          <div class="title-wrap">
            <b-form-row class="align-items-end">
              <!-- 보고서명 -->
              <b-col cols="9">
                <b-form-group>
                  <b-form-input name="title"
                                label="Title"
                                id="title"
                                ref="title"
                                placeholder="보고서명을 입력해주세요"
                                size="xl"
                                class="my-1"
                                style="height: 45px; font-size: 30px; border:none;"
                                v-model="disclosure.name"
                                v-validate="{ required: true }"
                                :state="validateState('title')"></b-form-input>
                </b-form-group>
              </b-col>
              <!-- 보고서명 -->

              <!-- 보고서 담당자 -->
              <b-col cols="3">
                <label for="assignee">담당자<span class="required">*</span></label>
                <b-form-group>
                  <b-form-select id="assignee-list"
                                 name="assignee"
                                 size="sm"
                                 ref="assignee"
                                 v-validate="{ required: true }"
                                 :state="validateState('assignee')"
                                 v-model="disclosure.manager"
                                 :options="assigneeOptions"
                                 class="custom-select">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <!-- /보고서 담당자 -->
            </b-form-row>
          </div>
        </div>

        <!-- 보고서 상세 영역 (상태, 시작/종료 일자, 설명) -->
        <div class="project-form-wrap">
          <div class="left-form-area">
            <!-- 상태 -->
            <div class="input-wrap">
              <label for="">상태</label>
              <b-dropdown right
                          :text="getTextOfOptions(disclosure.status)"
                          size="lg"
                          class="btn-select-status"
                          :class="getStatusClass(disclosure.status)">
                <b-dropdown-item v-for="option in disclosureStatusOptions"
                                 :key="option.value"
                                 :value="option.value"
                                 @click="disclosure.status = option.value">{{ option.text }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <!-- /상태 -->

            <!-- 시작/종료 일자 -->
            <div class="input-wrap">
              <label for="start-date">시작 - 종료일</label>
              <div class="date-wrap">
                <b-form-group>
                  <b-input-group class="form-inline">
                    <b-form-input id="start-date"
                                  name="start-date"
                                  type="date"
                                  v-model="disclosure.startDate"
                                  v-validate="dateRule"
                                  class="custom-input rounded"
                                  placeholder="YYYY-MM-DD"
                                  :state="validateState('start-date')"></b-form-input>
                    <b-form-invalid-feedback id="start-date-feedback">
                      형식에 맞춰 시작일자를 입력해주세요 (mm/dd/yyyy)
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
                <b-form-group>
                  <b-input-group class="form-inline">
                    <b-form-input id="end-date"
                                  name="end-date"
                                  type="date"
                                  v-model="disclosure.endDate"
                                  v-validate="dateRule"
                                  class="custom-input rounded"
                                  placeholder="YYYY-MM-DD"
                                  :state="validateState('end-date')"></b-form-input>
                    <b-form-invalid-feedback id="end-date-feedback">
                      형식에 맞춰 종료일자를 입력해주세요 (mm/dd/yyyy)
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </div>
          <!-- 시작/종료 일자 -->

          <!-- 보고서 상세 설명 -->
          <div class="right-form-area">
            <div>
              <label for="description">설명</label>
              <b-form-textarea class="description"
                               id="description"
                               name="description"
                               placeholder="해당 보고서의 방향성 및 주제 설명"
                               v-model="disclosure.description"
                               rows="5"
                               style="height: 139px;"></b-form-textarea>
              <b-form-invalid-feedback id="description-feedback">
                보고서 설명을 입력해주세요
              </b-form-invalid-feedback>
            </div>
          </div>
          <!-- 보고서 상세 설명 -->
        </div>
        <!-- 보고서 상세 영역 (상태, 시작/종료 일자, 설명) -->
      </b-card>

      <b-card class="methodology">
        <div class="card-header"
             id="methodology-card-header">
          <div class=" card-title-area">
            <b-icon icon="gear-wide-connected"/>
            <span class="title-text mr-1">목차</span>
            <b-form-group
                v-b-tooltip="{ title: disclosure.manager === '' ? '담당자를 지정하여 주십시오.' : '시작 / 종료 일자를 기입하여 주십시오.', placement: 'top', variant: 'danger', disabled: disclosure.manager !== '' && disclosure.startDate && disclosure.endDate }"
                style="margin-bottom:0px;">
              <b-select id="template"
                        style="width: 300px"
                        align-h="end"
                        @change="retrieveDisclosureTemplateItems"
                        v-model="selectedTemplate"
                        :disabled="disclosure.manager === '' || !disclosure.startDate || !disclosure.endDate">
                <option :value=null
                        disabled>양식 선택
                </option>
                <option v-for="option in templateOptions"
                        :key="option.value"
                        :value="option.value"
                        v-b-tooltip.hover
                        :title="option.text">{{ option.text }}
                </option>
              </b-select>
            </b-form-group>
          </div>
        </div>
        <div class="card-body">
          <!-- Table of Contents -->
          <esg-toc-management-grid v-show="selectedTemplate"
                                   ref="tocManagementGrid"
                                   :tableOfContents="disclosureItems"
                                   :deleted-items="null"
                                   :members="assigneeOptions"/>
          <!-- /Table of Contents -->
        </div>
      </b-card>
    </div>

    <!-- Spinner -->
    <loading :active="loading"
             :z-index="1000"/>
    <!-- /Spinner -->

    <!-- Buttons -->
    <div class="btn-container">
      <div class="btn-wrap">
        <esg-base-button @click="cancel"
                         class="mr-1"
                         variant="secondary">
          취소
        </esg-base-button>
        <esg-base-button @click="submit"
                         variant="primary">
          완료
        </esg-base-button>
      </div>
    </div>
    <!-- /Buttons -->
  </b-container>
</template>

<script>
import EsgTocManagementGrid from "./EsgDisclosureManagementGrid.vue";
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";

export default {
  components: { EsgBaseButton, EsgTocManagementGrid },
  data() {
    return {
      loading: false,
      disclosure: {
        status: "OPEN",
        name: "",
        projectId: "",
        description: "",
        manager: "",
        startDate: null,
        endDate: null,
        creator: "",
        creationDate: "",
        updater: "",
        updateDate: "",
      },

      selectedTemplate: null,
      templateOptions: [],
      disclosureItems: [],

      dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    disclosureStatusOptions() {
      return [
        { value: "OPEN", text: "OPEN", disabled: false, update: false },
        { value: "CLOSED", text: "CLOSED", disabled: false, update: true },
      ]
    },
    assigneeOptions() {
      return this.$store.getters['report/options']['assigneeOptions']
    },
  },
  watch: {
    selectedTemplate: {
      handler(newTemplate, oldTemplate) {
        if (newTemplate !== oldTemplate) {
          this.retrieveDisclosureTemplateItems();
        }
      }
    }
  },
  created() {
    this.retrieveDisclosureTemplates();
  },
  methods: {
    async retrieveDisclosureTemplates() {
      try {
        this.loading = true;
        let response = await axios.get('esg/disclosure/disclosure-templates', {
          headers: { Authorization: accessToken() }
        });

        if (!response.data.list) return;

        this.templateOptions = response.data.list.map(obj => ({ value: obj.id, text: obj.title }));
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async retrieveDisclosureTemplateItems() {
      try {
        this.loading = true;
        let response = await axios.get('esg/disclosure/disclosure-templates/' + this.selectedTemplate, {
          headers: { Authorization: accessToken() }
        });

        if (!response.data) return;
        this.initializeTocInfo(response.data.tableOfContents, this.disclosure.startDate, this.disclosure.endDate, this.disclosure.manager);
        this.disclosureItems = response.data.tableOfContents;
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    initializeTocInfo(data, startDateValue, endDateValue, assigneeValue) {
      if (Array.isArray(data)) {
        // 배열일 경우 배열의 각 요소에 대해 함수를 호출
        data.forEach((item) => {
          this.initializeTocInfo(item, startDateValue, endDateValue, assigneeValue);
        });
      } else if (typeof data === 'object' && data !== null) { // null 체크를 추가
        // 객체일 경우 startDate와 endDate 값을 설정
        data.startDate = startDateValue;
        data.endDate = endDateValue;
        data.assignee = assigneeValue;
        // 객체 내의 모든 속성에 대해 함수를 호출
        for (const key in data) {
          this.initializeTocInfo(data[key], startDateValue, endDateValue, assigneeValue);
        }
      }
    },
    async submit() {
      try {
        this.loading = true;

        // Validate the ESG disclosure form
        if (!await this.validateForm()) {
          return;
        }

        this.preprocess(this.disclosureItems);
        this.disclosure.tableOfContents = this.disclosureItems;

        await axios.post('esg/disclosure/disclosures', this.disclosure, {
          headers: { Authorization: accessToken() }
        });

        this.loading = false;

        this.showMessageInToast('보고서가 생성되었습니다.');

        this.pushRoute('/esg/disclosures')
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    preprocess(root) {
      if (typeof root === "object" && root.children) {
        root = root.children;
      }
      root.forEach((child, index) => {
        // Remove parent field to remove circular reference (if not, causes an error when converting to JSON)
        delete child.parent;
        child.startDate = child.startDate === '' ? null : child.startDate
        child.endDate = child.endDate === '' ? null : child.endDate
        // Remove UUID (if not, causes an error when converting to JSON)
        delete child.id;

        // Set order among its siblings
        child.order = index;
        this.preprocess(child);
      });
    },
    getStatusClass(status) {
      if (status === 'OPEN') return 'open'
      else if (status === 'CLOSED') return 'closed'
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    getTextOfOptions(status) {
      // statusOptions 배열에서 status 값과 value가 같은 객체 찾기
      const matchedOption = this.disclosureStatusOptions.find(option => option.value === status);
      // 찾은 객체가 있으면 해당 객체의 text 값을 반환하고, 없으면 빈 문자열 반환
      return matchedOption ? matchedOption.text : '';
    },
    cancel() {
      this.pushRoute('/esg/disclosures');
    },
  }
}
</script>

<style>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

#disclosure-new-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#disclosure-new-form .custom-select {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

span.required {
  color: red;
}

.image-title {
  display: block;
  margin-bottom: .3rem;
}

.image-box {
  display: block;
  max-width: 100%;
}

.hide-toolbar .ql-toolbar {
  display: none;
}

.hide-border .ql-container {
  border: none !important;
}

.custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

.custom-tags {
  height: 1.1rem !important;
}

#disclosure-new-form .custom-input {
  height: 2em !important;
}

#disclosure-new-form .dropdown-toggle {
  height: 2em !important;
  padding: 0 !important;
}

#disclosure-new-form #tag-search-input {
  height: 2em;
  margin: 0;
}

#disclosure-new-form .dropdown-item {
  height: 1.9rem;
  font-size: 0.8em !important;
}

#disclosure-new-form #tags-with-dropdown {
  border: none;
  padding: 0 !important;
}

#disclosure-new-form .b-dropdown-form {
  height: 3em;
}

#disclosure-new-form #description {
  height: 4em;
}

#disclosure-new-form .btn {
  width: 100%;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  /* background: #F6F6FA; */
  /* color: #AAA; */
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

/* 신규 스타일 Start */
/* 신규 추가 스타일 */
#disclosure-new-form .btn-select-status .dropdown-toggle {
  position: relative;
  display: flex !important;
  align-items: center !important;
  gap: 0 0.933rem !important;
  min-height: 2.666rem;
  padding: 0.533rem 2.8rem 0.533rem 0.8rem !important;
  color: #1B1B1B;
  background-color: #FFF;
  font-family: 'NanumGothic' !important;
  font-size: 17px !important;
  font-weight: 400 !important;
  line-height: 42px !important;
}

#disclosure-new-form .btn-select-status .dropdown-toggle:hover {
  background-color: #FFF;
}

#disclosure-new-form .badge-container .badge.open {
  background-color: #CFDDFF;
  color: #1755CC;
}

#disclosure-new-form .btn-select-status .dropdown-toggle::after {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 0;
  content: "";
  border: none;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

#disclosure-new-form .card .card-body {
  margin-top: 0em;
  padding-top: 0%;
  padding-bottom: 1%;
}

#disclosure-new-form .card .card-header {
  padding-left: 0;
  background-color: white !important;
  padding: 0;
  border-bottom: none !important;
}

#disclosure-new-form .card #role-card-header,
#disclosure-new-form .card #methodology-card-header {
  margin-bottom: 1em !important;
}

#disclosure-new-form .card {
  margin-bottom: 2rem !important;
  border-radius: 30px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#disclosure-new-form .card > .card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
}

#disclosure-new-form .card .card-body .card-body {
  padding: 0;
}

#disclosure-new-form .card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

#disclosure-new-form .card.description .card-body {
  padding: 0.666rem 0.666rem 1.666rem;
}

#disclosure-new-form input.form-control {
  height: 40px !important;
  background-color: #FFF;
}

#disclosure-new-form input[type="date"].form-control {
  padding: 8px 12px;
}

#disclosure-new-form input#projectId {
  height: 45px !important;
  padding: 0;
  margin-bottom: 0;
  background-color: #FFF;
  border: none;
  color: #1B1B1B;
  font-family: 'NanumGothic';
  font-size: 30px;
  font-weight: 400;
  line-height: 150%;
}

#disclosure-new-form input#projectId::placeholder {
  color: #AAA;
  font-size: 30px;
}

#disclosure-new-form .project-id {
  display: inline-block;
  margin-bottom: 1rem;
  padding: 8px 16px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  background-color: #F6F6FA;
  color: #2E2E38;
}

#disclosure-new-form .form-control#title {
  height: 45px !important;
  padding: 0;
  background-color: transparent;
  border: none;
  font-weight: 700;
}

#disclosure-new-form .form-control#title::placeholder {
  color: #AAA;
  font-size: 30px;
}

#disclosure-new-form .btn-select-status .dropdown-toggle-original {
  display: flex;
  align-items: center;
  gap: 0 0.933rem;
  height: 100%;
  padding: 0.266rem 1.066rem 0.266rem 1.6rem;
  border: none;
  border-radius: 38px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}

#disclosure-new-form .add-wrap .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

#disclosure-new-form .add-wrap .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

#disclosure-new-form .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

#disclosure-new-form .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

#disclosure-new-form .add-wrap .card.user {
  width: 33%;
  overflow: hidden;
}

#disclosure-new-form .add-wrap .card.member {
  width: 67%;
  overflow: hidden;
}

#disclosure-new-form .add-wrap {
  display: flex;
  gap: 0 2rem;
}

#disclosure-new-form .add-wrap .card > .card-body {
  padding: 0;
}

#disclosure-new-form .add-wrap .card .card-body .card-header {
  padding: 2rem 2.0833vw;
  border-radius: 30px 30px 0 0;
}

#disclosure-new-form .add-wrap .card .card-body .card-body {
  padding: 0 2.0833vw;
  margin-bottom: 0.4rem;
  max-height: 40.333rem;
  min-height: 15.333rem;
  overflow-y: auto;
}

#disclosure-new-form .b-form-tags .badge {
  display: inline-flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  line-height: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  height: 2em;
}

#disclosure-new-form .description {
  border-radius: 13px !important;
  height: 4em;
  border: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  padding: 0.533rem 1.066rem;
}

#disclosure-new-form .card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

#disclosure-new-form .add-wrap .card-title-area .total-num,
#disclosure-new-form .card-title-area .total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #FFE500;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}

#disclosure-new-form .tag-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 0.666rem;
  margin-left: 1.333rem;
}

#disclosure-new-form .tag-list::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translateY(-50%);
  width: 1px;
  height: 24px;
  background-color: #DDDDE3;
}

#disclosure-new-form .b-form-tags .badge {
  gap: 0 0.666rem;
  height: 2.666rem;
  padding: 0.266rem 0.8rem 0.266rem 1.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  border-radius: 60px;
  border: 1px solid #DDDDE3;
  background-color: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#disclosure-new-form label {
  font-family: 'NanumGothic';
}

#disclosure-new-form .title-wrap .input-wrap:first-child {
  min-width: 393px;
  flex-shrink: 0;
}

#disclosure-new-form .project-form-wrap {
  display: flex;
  gap: 2rem;
  margin-top: 2.666rem;
}

#disclosure-new-form .project-form-wrap .input-wrap {
  display: flex;
  flex-direction: column;
}

#disclosure-new-form .project-form-wrap .left-form-area {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  min-width: 393px;
  flex-shrink: 0;
}

#disclosure-new-form .project-form-wrap .left-form-area .date-wrap {
  display: flex;
  gap: 0 1.333rem;
}

#disclosure-new-form .project-form-wrap .date-wrap .form-group {
  width: calc(50% - 10px);
}

#disclosure-new-form .project-form-wrap .date-wrap .form-group:first-child {
  position: relative;
}

#disclosure-new-form .project-form-wrap .date-wrap .form-group:first-child::after {
  content: '~';
  display: block;
  position: absolute;
  top: 50%;
  right: -15px;
  transform: translateY(-50%);
  color: #747480;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#disclosure-new-form .project-form-wrap .date-wrap .custom-input {
  height: 2.666rem !important;
  background-color: #FFF;
}

#disclosure-new-form .project-form-wrap .right-form-area {
  flex-grow: 1;
  flex-shrink: 0;
}

#disclosure-new-form .input-wrap.border-bottom {
  padding-bottom: 20px;
  border-bottom: 1px solid #DDDDE3;
}

#disclosure-new-form .input-wrap.title {
  flex-grow: 1;
  flex-shrink: 0;
}

#disclosure-new-form .project-tab-card .card-header {
  border-radius: 20px 20px 0 0;
}

#disclosure-new-form .project-tab-card .card-header-tabs {
  gap: 0 30px;
  padding: 20px 0 0;
  margin: 0 40px;
  border-bottom: 1px solid #DDDDE3;
}

#disclosure-new-form .project-tab-card .nav-tabs .nav-item {
  margin-bottom: 0;
}

#disclosure-new-form .project-tab-card .nav-tabs .nav-link {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

#disclosure-new-form .project-tab-card .nav-tabs .nav-link.active,
#disclosure-new-form .project-tab-card .nav-tabs .nav-item.show .nav-link {
  color: #2E2E38;
  font-weight: 700;
  border-bottom: 3px solid #2E2E38;
}

#disclosure-new-form .project-tab-card .nav-tabs .nav-link.disabled {
  color: #C4C4CD;
}

#disclosure-new-form .project-tab-card .tab-content {
  padding: 40px 2.0833vw;
}

#disclosure-new-form .card .card-body.tab-pane {
  padding: 0;
}

#disclosure-new-form .project-tab-card .custom-select {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

#disclosure-new-form .project-tab-card .methodology-select {
  max-width: 328px;
}

#disclosure-new-form .project-tab-card .custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

#disclosure-new-form .project-tab-card .btn-clear {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: rgba(255, 0, 0, 0.10);
  color: #F00;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

#disclosure-new-form .project-tab-card .btn-clear:hover {
  color: #F00;
}

#disclosure-new-form .project-tab-card .roles-wrap {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
}

#disclosure-new-form .project-tab-card .roles-wrap .btn-black {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  height: 40px !important;
  padding: 0.266rem 1.6rem 0.266rem 0.8rem !important;
  color: #FFF;
  border: none;
  border-radius: 60px;
  background-color: #2E2E38;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

#disclosure-new-form .project-tab-card .roles-wrap .btn-black .icon.plus {
  display: block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 10H15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 15L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu {
  min-width: 33.3rem;
  margin-top: 10px;
  padding: 20px;
  border-radius: 20px;
  border: none;
  background-color: #FFF;
  box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form {
  padding: 0;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row {
  margin: 0;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row label {
  padding: 0;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .b-dropdown-form .form-row > .col {
  padding: 0;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-divider {
  display: none;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-item {
  height: 36px;
  padding: 6px 10px;
  border-radius: 10px;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px !important;
  font-weight: 500;
  line-height: 150%;
}

#disclosure-new-form .project-tab-card .roles-wrap .dropdown-menu .dropdown-item:hover {
  background-color: #F6F6FA;
  color: #2E2E38;
  font-weight: 700;
}

#disclosure-new-form .project-tab-card .members-wrap {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

#disclosure-new-form .project-tab-card .members-wrap .members-content {
  position: relative;
  padding: 2rem 1.5625vw;
  border-radius: 20px;
  border: 1px solid #DDDDE3;
}

#disclosure-new-form .project-tab-card .members-wrap .members-content.users {
  width: 36%;
  overflow: hidden;
}

#disclosure-new-form .project-tab-card .members-wrap .members-content.members {
  width: 64%;
}

#disclosure-new-form .project-tab-card .members-wrap .members-content .title {
  height: 60px;
  color: #000;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
}

#disclosure-new-form .project-tab-card .members-wrap .members-content.users .btn-assign {
  position: absolute;
  top: 20px;
  right: 30px;
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background-color: #747480;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}
</style>